import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLoadingCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLoadingCircle"><Path d="M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12Z" stroke="currentColor" strokeOpacity="0.3" strokeWidth="3"/><Path d="M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5" stroke="currentColor" strokeWidth="3"/></CentralIconBase>;
});

export default IconLoadingCircle;
